import { Box } from "@mui/material";
import ColoredChipsCell, { ColoredChipItem } from "@common/components/coloredChipsCell/ColoredChipsCell";
import TopBarTextTile from "./TopBarTextTile";

export interface TopBarChipsTileProps {
    label: string;
    chips: Array<ColoredChipItem> | undefined;
    isLoading?: boolean;
}

// Shows the first chips and a "+N" the way the list cells do, so a tile reads the same as the column it mirrors.
function TopBarChipsTile(props: TopBarChipsTileProps) {
    const chips = props.chips ?? [];
    return (
        <TopBarTextTile
            label={props.label}
            neverShowTooltip
            isLoading={props.isLoading}
            value={
                chips.length > 0 ? (
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <ColoredChipsCell items={chips} visibleCount={2} />
                    </Box>
                ) : undefined
            }
        />
    );
}

export default TopBarChipsTile;
